export enum FileProcessingRequestStatus {
  RECEIVING = "RECEIVING",
  RECEIVED = "RECEIVED",
  VALIDATING = "VALIDATING",
  VALIDATED = "VALIDATED",
  PROCESSING = "PROCESSING",
  VALIDATING_PHONE_NUMBERS = "VALIDATING_PHONE_NUMBERS",
  UPLOADED = "UPLOADED",
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
  INVALID_FORMAT = "INVALID_FORMAT",
  INDEXING_FAILED = "INDEXING_FAILED",
}

export enum FileProcessingType {
  DONORS_UPLOAD = "DONORS_UPLOAD",
}

export enum FileProcessingErrorCode {
  INVALID_MIME_TYPE = "INVALID_MIME_TYPE",
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  INVALID_FIELD_VALUES = "INVALID_FIELD_VALUES",
  IMPORT_IN_PROGRESS = "IMPORT_IN_PROGRESS",
}

export type FileUploaderIdentifier = {
  userId: string;
  userEmail: string;
  userName: string;
};

export type FileProcessingRequest = {
  fileName: string;
  fileExtension: string;
  fileSize: number;
  filePath: string;
  fileUrl: string;
  mimeType: string;
  bucketName?: string;
  type: FileProcessingType;
  status: FileProcessingRequestStatus;
  errorCode?: FileProcessingErrorCode;
  errorDescription?: string;
  error?: {
    code?: string;
    message?: string;
    stack?: string;
    timestamp?: string;
  };
  uploadedBy: FileUploaderIdentifier;
  uploadedDateTimestamp: number;
  metadata?: object;
};

export const inFlightFileRequestStatuses: FileProcessingRequestStatus[] = [
  FileProcessingRequestStatus.RECEIVING,
  FileProcessingRequestStatus.RECEIVED,
  FileProcessingRequestStatus.VALIDATING,
  FileProcessingRequestStatus.VALIDATED,
  FileProcessingRequestStatus.PROCESSING,
  FileProcessingRequestStatus.UPLOADED,
  FileProcessingRequestStatus.VALIDATING_PHONE_NUMBERS,
];

export type Segment = {
  name: string;
  isKeyword: boolean;
};

export type SelectOption = {
  label: string;
  value: string;
};
